import { Suspense } from "react"
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../shared/components/loading/LoadingSpinner"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { DevicesMerchantAdminResponse, fetchAllDevices } from "../adminDevicesApi"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useApiQueryTable } from "../../../../../core/api/components/ApiQueryTable"
import { DeviceTable } from "../../../../entities/devices/components/DeviceTable"
import { DeviceTableVariant } from "../../../../entities/devices/deviceTypes"

const selectDevices = (data: DevicesMerchantAdminResponse) => data?.devices || []

type MerchantAdminDevicesTableProps = Readonly<{}>

function MerchantAdminDevicesTable({}: MerchantAdminDevicesTableProps) {
    const { merchantId } = useMerchant()

    const devicesResult = useApiQuery(fetchAllDevices, {
        queryName: "devices-for-merchant",
        dependencies: {
            merchantId,
        },
        enabled: Boolean(merchantId),
        select: selectDevices,
    })
    const { ApiQueryTable } = useApiQueryTable(devicesResult)

    return <DeviceTable variant={DeviceTableVariant.MERCHANT} ApiQueryTable={ApiQueryTable} />
}

export function MerchantAdminDevices() {
    return (
        <>
            <LocalizedStrict id="merchant-admin-devices-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_ADMIN_DEVICES}
                    title="Devices"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-shops">
                            <Breadcrumb>Shops</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-devices">
                            <Breadcrumb>Devices</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <MerchantAdminDevicesTable />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
